import logo from './logo.svg'

export const WlsyLogo = () => (
  <div className="mb-s flex min-h-[40px] min-w-[40px] items-center justify-center">
    <img src={logo} alt="Wlsy Logo" />
  </div>
)
